export default __webpack_public_path__ + "static/media/EitanLogo.f0c3ca6e.PNG";